import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Message } from "primereact/message";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { countryActions } from "../../store/country-store/country-slice";
import { uiActions } from "../../store/ui-slice";
import { useEffect } from "react";
import { getTokenInfo } from "../../utils/Guard";

let restartPage = false;

const CountryForms = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const country = props.country;
  const isValid = useSelector((state) => state.country.countryValidation);
  const userInfo = getTokenInfo();
  const notification = useSelector((state) => state.ui.notification);

  const onChangeHandler = (id, value) => {
    dispatch(countryActions.modifyPropertyValue({ id, value }));
    if (value !== "") {
      dispatch(countryActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(countryActions.setFieldValid({ id, value: false }));
    }
  };
  useEffect(() => {
    if (
      notification &&
      notification.status === "success" &&
      country.id > 0 &&
      restartPage
    ) {
      dispatch(countryActions.restartState());
      window.location.href = "/country";
    }
  }, [country.id, dispatch, navigate, notification]);
  const getFormErrorMessage = (id) => {
    return !isValid[id].isValid ? (
      <Message severity="warn" text={isValid[id].errorMessage} />
    ) : (
      <small className="p-warn">&nbsp;</small>
    );
  };
  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (country.name === "") {
      dispatch(countryActions.setFieldValid({ id: "name", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    } 
    // if (country.code === "") {
    //   dispatch(countryActions.setFieldValid({ id: "code", value: false }));
    //   dispatch(
    //     uiActions.showNotification({
    //       status: "warning",
    //       title: "Advertencia",
    //       message: "Existen valores invalidos, favor de revisar.",
    //     })
    //   );
    // }
    else {
      dispatch(props.actionCountry(country, userInfo.Email));
      restartPage = true;
    }
  };

  return (
    <>
      <Card
        style={{
          backgroundColor: "#F9FAFB",
          boxShadow: "none",
          height: "auto",
          width: "100%",
        }}
      >
        <form onSubmit={onSubmitHandler}>
          <div className="formgrid grid">
            <div className="field col-12 md:col-12">
              <h2 className="card-header" style={{ color: "" }}>
                País:
                <span style={{ color: "#D34330", marginLeft: "1%" }}>
                  {country && country.name && country.name}
                </span>
              </h2>
            </div>
            <div className="field col-12 md:col-6">
              <label htmlFor="name" style={{ fontSize: "large", color: "" }}>
                Nombre:
              </label>
              <InputText
                id="name"
                value={country.name}
                onChange={(e) => onChangeHandler("name", e.target.value)}
                placeholder=""
                style={{ width: "59.5rem" }}
              />
              <div>{getFormErrorMessage("name")}</div>
            </div>
            {/* <div className="field col-12 md:col-8">
              <label htmlFor="Code" style={{ fontSize: "large", color: "" }}>
                Código:
              </label>
              <InputText
                id="code"
                value={country.code}
                onChange={(e) => onChangeHandler("code", e.target.value)}
                placeholder=""
                style={{ width: "59.5rem" }}
              />
              <div>{getFormErrorMessage("code")}</div>
            </div> */}
            
          </div>
          <div className="formgrid grid">
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff" }}
              label="Regresar"
              icon="pi pi-arrow-left"
              className="p-button-danger"
              onClick={() => {
                navigate("/country");
              }}
            />
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff", marginLeft: "1%" }}
              label="Guardar"
              className="p-button-success"
              icon={
                notification && notification.status === "pending"
                  ? "pi pi-spin pi-spinner"
                  : "pi pi-save"
              }
              disabled={notification && notification.status === "pending"}
            />
          </div>
        </form>
      </Card>
    </>
  );
};
export default CountryForms;
